import script from "./StarRating.vue?vue&type=script&setup=true&lang=ts"
export * from "./StarRating.vue?vue&type=script&setup=true&lang=ts"

import "./StarRating.vue?vue&type=style&index=0&id=1ebeb2fc&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ebeb2fc"]])

export default __exports__